import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Settings, Globe, MessageCircle, Handshake } from "lucide-react";
import { useAuth } from "../auth";
import { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";

export default function OxyHeader() {
  const { user, logout } = useAuth();
  const [oxy, setOxy] = useState(null);
  useEffect(() => { api.get("/oxy/settings").then(r => setOxy(r.data)).catch(()=>{}); }, []);

  const logo = oxy?.platform_logo_url ? (
    <img src={fileUrl(oxy.platform_logo_url)} alt={oxy.brand_name || "OxyCom"} className="h-8"/>
  ) : (
    <>
      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-500 via-cyan-500 to-emerald-500 flex items-center justify-center text-white font-black text-sm">O</div>
      <span className="font-extrabold hidden sm:block">{oxy?.brand_name?.startsWith("Oxy") ? <>Oxy<span className="text-sky-500">Com</span></> : (oxy?.brand_name || "OxyCom")}</span>
    </>
  );

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/dashboard" className="flex items-center gap-2">{logo}</Link>
        <nav className="hidden md:flex items-center gap-1 text-sm font-medium text-slate-700">
          <Link to="/dashboard"><Button variant="ghost" size="sm" data-testid="nav-websites"><Globe className="w-4 h-4 mr-1.5"/>Websites</Button></Link>
          <Link to="/affiliate"><Button variant="ghost" size="sm" data-testid="nav-affiliate"><Handshake className="w-4 h-4 mr-1.5"/>Affiliate</Button></Link>
          <Link to="/support"><Button variant="ghost" size="sm" data-testid="nav-support"><MessageCircle className="w-4 h-4 mr-1.5"/>Support</Button></Link>
          {user?.role === "super_admin" && (
            <Link to="/admin"><Button variant="ghost" size="sm" data-testid="nav-admin"><Settings className="w-4 h-4 mr-1.5"/>Admin</Button></Link>
          )}
        </nav>
        <div className="flex items-center gap-3">
          {user?.picture && <img src={user.picture} alt="" className="w-8 h-8 rounded-full border-2 border-sky-200"/>}
          <div className="hidden sm:block text-sm">
            <div className="font-semibold leading-tight">{user?.name}</div>
            <div className="text-xs text-slate-500 leading-tight">{user?.role}</div>
          </div>
          <Button size="sm" variant="ghost" onClick={logout} data-testid="logout"><LogOut className="w-4 h-4"/></Button>
        </div>
      </div>
    </header>
  );
}
